import React, { Component } from 'react';
import firebase from 'firebase';

class ListOfGuardians extends Component {
    constructor() {
        super();
        this.state = {
            guardianList: [],
        }
    }
    //Display the list of guardians from firebase with name and adopted pokemon. 
    renderGuardianList() {
        const guardianListArray = this.state.guardianList.map((response,  i) => {
            return (
                <div key={i} className="listTilesContainer">
                    <div className="listTiles">
                        <p className="guardiansName">{response.Name}</p>
                        <ul>
                        { this.state.guardianList[i].Collection.map((response, i) => {
                            return ( 
                                <li key={i} className="list">{response}</li>
                            )
                        })}
                        </ul>
                    </div>
                </div>
            )
        });
        return (<div className="guardianListFlex">{guardianListArray}</div>);
    }
    //Displays when there are no guardians save from firebase.
    renderEmptyState() {
        return (
            <div className="adoptionEmpty wrapper">
                <p>Be the first one...</p>
            </div>
        )
    }
    componentDidMount() {
        const dbRef = firebase.database().ref("Guardians");
    
        dbRef.on('value', data => {
            const response = data.val();
            const newState = [];

            for (let key in response) {
                newState.push({
                    Collection: response[key].Collection,
                    Name: response[key].Name,
                    uniqueKey: key,
                });
            }
            this.setState({
                guardianList: newState,
            });
        });
    }

    render(){
        return(
            <section>
                <div className="wrapperList">
                    <h2 className="guardiansTitle">list of guardians</h2>
                    <div>
                        {this.state.guardianList.length ? this.renderGuardianList() : this.renderEmptyState()} 
                    </div>
                </div>
            </section>
        )
    }
}
    
export default ListOfGuardians;